import { useState } from "react";
import { scheduleData, scheduleRounds, type ScheduleItem } from "@/mocks/chigua";

const statusMeta: Record<ScheduleItem["status"], { label: string; cls: string; icon: string }> = {
  result: { label: "已结束", cls: "bg-background-200 text-foreground-600", icon: "ri-check-line" },
  live: { label: "进行中", cls: "bg-primary-500 text-background-50", icon: "ri-radio-button-line" },
  upcoming: { label: "未开始", cls: "bg-accent-100 text-accent-700", icon: "ri-time-line" },
};

export default function Schedule() {
  const [active, setActive] = useState("sf");
  const items = scheduleData[active];

  return (
    <section id="schedule" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-1.5 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-sm font-bold uppercase tracking-wide text-primary-600">赛程安排 Schedule</p>
            <h2 className="mt-2 font-heading text-3xl leading-tight text-foreground-950 md:text-4xl">
              每一轮都有看点，时间表全在这
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            从小组海选到总决赛之夜，按轮次查看完整对阵时间与晋级结果，下一场对决一目了然。
          </p>
        </div>

        {/* segmented round tabs */}
        <div className="mt-8 inline-flex max-w-full flex-wrap gap-1 rounded-full bg-background-100 p-1">
          {scheduleRounds.map((r) => (
            <button
              key={r.key}
              type="button"
              onClick={() => setActive(r.key)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold transition-colors ${
                active === r.key
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:bg-background-200 hover:text-foreground-950"
              }`}
            >
              {r.name}
            </button>
          ))}
        </div>

        {/* legend */}
        <div className="mt-4 flex flex-wrap items-center gap-4 text-xs text-foreground-600">
          {(Object.keys(statusMeta) as ScheduleItem["status"][]).map((s) => (
            <span key={s} className="inline-flex items-center gap-1.5">
              <span className={`flex h-5 w-5 items-center justify-center rounded-full ${statusMeta[s].cls}`}>
                <i className={`text-[10px] ${statusMeta[s].icon}`} aria-hidden="true"></i>
              </span>
              {statusMeta[s].label}
            </span>
          ))}
        </div>

        {/* list */}
        <div className="mt-5 overflow-hidden rounded-3xl border border-background-200">
          <ul className="divide-y divide-background-100">
            {items.map((m) => (
              <li key={m.day + m.time} className="flex flex-col gap-3 px-5 py-4 transition-colors hover:bg-background-100/70 sm:flex-row sm:items-center md:px-6">
                <div className="flex w-full items-center gap-4 sm:w-[200px] sm:shrink-0">
                  <div className="flex flex-col items-center rounded-xl bg-background-100 px-3 py-1.5">
                    <span className="font-label text-xs font-bold text-foreground-500">{m.day.split("-")[0]}月</span>
                    <span className="font-heading text-xl leading-none text-foreground-950">{m.day.split("-")[1]}</span>
                  </div>
                  <div>
                    <p className="font-heading text-sm text-foreground-950">{m.round}</p>
                    <p className="text-xs text-foreground-500">{m.time}</p>
                  </div>
                </div>

                <div className="flex-1">
                  <p className="text-sm font-semibold text-foreground-900">{m.title}</p>
                  <p className="mt-0.5 text-xs text-foreground-500">{m.note}</p>
                </div>

                <span
                  className={`inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-1 text-xs font-bold ${statusMeta[m.status].cls}`}
                >
                  <i className={`text-[10px] ${statusMeta[m.status].icon}`} aria-hidden="true"></i>
                  {statusMeta[m.status].label}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}